// TODO: Document
import launchDarkly from './launchDarkly';
class OnlineOrderingScriptLoader {
	constructor() {
		// window.onlineOrderingURL is the location of the online ordering react site/scripts
		// window.onlineOrderingURL should be set as a window var from the Kentico site back end
		// falls back to localhost:3000 for local online ordering server
		window.onlineOrderingURL =
			window.onlineOrderingURL ||
			`${document.location.protocol}//${document.location.hostname}:3000`;

		this.manifest = null;
		this.fetchManifest().then(() => {
			if (this.manifest) {
				this.loadJS();
				this.loadCSS();
			}
		});
	}

	fetchManifest = () => {
		const cacheKillerDate = Date.now();
		return fetch(
			`${window.onlineOrderingURL}/asset-manifest.json?lastUpdated=${cacheKillerDate}`
		)
			.then((res) => res.json())
			.then((data) => {
				this.manifest = data;
				const mainJS = data['main.js'];
				const mainCSS = data['marketing.css'];
				this.javascriptURL = `${window.onlineOrderingURL}${mainJS}`;
				this.cssURL = `${window.onlineOrderingURL}${mainCSS}`;
				return data;
			})
			.catch((err) => {
				console.error('Could not fetch online ordering asset manifest', err);
			});
	};

	loadJS = () => {
		if (this.javascriptURL) {
			const body = document.querySelector('body');
			body.addEventListener('onlineorder-loaded', () => {
				if (window.launch_darkly_key) {
					launchDarkly.init();
				}
			});
			const head = document.querySelector('head');
			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = this.javascriptURL;
			script.async = true;
			head.append(script);

		} else {
			console.warn('Not loading online ordering JavaScript', this);
		}
	};

	loadCSS = () => {
		if (this.cssURL) {
			const head = document.querySelector('head');
			const link = document.createElement('link');
			link.rel = 'stylesheet';
			link.href = this.cssURL;
			head.append(link);
		} else {
			console.warn('Not loading online ordering CSS', this);
		}
	};
}

new OnlineOrderingScriptLoader();
